export default "__VITE_ASSET__CKx8s3ka__"